<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-card>
      <b-tabs pills align="center">
        <validation-observer ref="headerForm">
          <b-card-text class="card-title">User Register</b-card-text>
          <hr />
          <b-card>
            <b-row class="pt-1">
              <b-col md="12">
                <b-form-group
                  label-for="i-name"
                  :label="locals('leadcust.name')"
                  class="title-freight-require"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="locals('leadcust.name')"
                    rules="required"
                  >
                    <b-form-input
                      id="i-name"
                      v-model="listData.strName"
                      autocomplete="off"
                      :disabled="isEdit"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-firstname"
                  :label="locals('leadcust.firstname')"
                  class="title-freight-require"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="locals('leadcust.firstname')"
                    rules="required"
                  >
                    <b-form-input
                      id="i-firstname"
                      v-model="listData.strFirstName"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-surname"
                  :label="locals('leadcust.surname')"
                  class="title-freight-require"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="locals('leadcust.surname')"
                    rules="required"
                  >
                    <b-form-input
                      id="i-surname"
                      v-model="listData.strSurName"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-email"
                  :label="locals('leadcust.email')"
                  class="title-freight-require"
                  valid-feedback="Completed!"
                  :invalid-feedback="validateEmail"
                  :state="stateEmail"
                >
                  <b-form-input
                    id="i-email"
                    v-model="listData.strEmail"
                    :class="{ 'is-invalid': !isEmailValid }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-telno"
                  :label="locals('leadcust.telno')"
                  class="title-freight-require"
                  valid-feedback="Completed!"
                  :invalid-feedback="validateTelNo"
                  :state="stateTelNo"
                >
                  <b-form-input
                    id="i-telno"
                    v-model="listData.strTelNo"
                    type="number"
                    :class="{ 'is-invalid': !isTelNoValid }"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="locals('leadcust.department2')"
                  label-for="i-main"
                  class="title-freight-require"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="locals('leadcust.department2')"
                    rules="required"
                  >
                    <v-select
                      input-id="i-main"
                      :clearable="true"
                      v-model="listData.intDeptId"
                      :placeholder="locals('select.placeholder')"
                      label="strDeptName"
                      :reduce="(val) => val.intDeptId"
                      :options="departmentOption"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-role"
                  :label="locals('leadcust.user_role')"
                  class="title-freight-require"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="locals('leadcust.user_role')"
                    rules="required"
                  >
                    <v-select
                      v-model="listData.strRole"
                      :placeholder="locals('select.placeholder')"
                      :options="MainOptions"
                      :reduce="(val) => val.strDsName"
                      label="strDsDesc"
                      :clearable="true"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <hr />
              <b-row>
                <b-col md="6" class="pt-2">
                  <b-form-checkbox
                    v-model="listData.select_flag"
                    class="title-freight"
                  >
                    ตั้งค่า Password
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col md="6">
                  <b-form-group
                    label-for="i-input-password"
                    label="Password"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Input Password"
                      :rules="listData.select_flag ? 'required' : ''"
                      autocomplete="off"
                    >
                      <b-form-input
                        id="i-input-password"
                        type="password"
                        autocomplete="off"
                        v-model="listData.strInputPassword"
                        :disabled="!listData.select_flag"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-for="i-confirm-password"
                    label="Confirm Password"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Confirm Password"
                      :rules="listData.select_flag ? 'required' : ''"
                    >
                      <b-form-input
                        id="i-confirm-password"
                        type="password"
                        autocomplete="off"
                        v-model="listData.strConfirmPassword"
                        :disabled="!listData.select_flag"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </validation-observer>
      </b-tabs>
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSubmit('Submit')"
          >
            <font-awesome-icon icon="fa-solid fa-check" />
            {{ $t("button.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="onBack"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseCheck from "@core/components/app-collapse/AppCollapseCheck.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import base64toblob from "base64toblob";

import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BPagination,
  BInputGroupPrepend,
  BFormFile,
  BTabs,
  BTab,
  BCardText,
  BModal,
  VBModal,
  BSpinner,
  BOverlay,
  VBTooltip,
} from "bootstrap-vue";

import Service from "@/@API/cDropdown";
import UserService from "@/@API/cUser";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    AppCollapse,
    AppCollapseItem,
    AppCollapseCheck,
    BFormRadio,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormCheckbox,
    BFormSelect,
    vSelect,
    flatPickr,
    BFormTextarea,
    VueGoodTable,
    BPagination,
    BInputGroupPrepend,
    BButton,
    BFormFile,
    Cleave,
    BTabs,
    BTab,
    BCardText,
    BModal,
    VBModal,
    BSpinner,
    BOverlay,
    VBTooltip,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      strInputStatus: "",
      strStatusShow: "",
      showCustomerName: "",
      showStatus: "",
      showBy: "",
      busy: true,
      processing: false,
      isLoading: true,
      isSaving: false,
      isEdit: false,
      ifView: false,
      enterPressed: false,
      enterPressed2: false,
      isEmailValid: true,
      isTelNoValid: true,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          numeralDecimalScale: 3,
        },
      },
      departmentOption: [],
      MainOptions: [
        {
          intDsId: 1,
          strDsDesc: "IT Admin",
          strDsName: "ROLE_SYSTEM",
        },
        {
          intDsId: 2,
          strDsDesc: "APP Admin",
          strDsName: "ROLE_ADMIN",
        },
        {
          intDsId: 5,
          strDsDesc: "Reviewer",
          strDsName: "ROLE_REVIEWER",
        },
        {
          intDsId: 6,
          strDsDesc: "Approver",
          strDsName: "ROLE_APPROVER",
        },
        {
          intDsId: 3,
          strDsDesc: "User",
          strDsName: "ROLE_USER",
        },
        {
          intDsId: 4,
          strDsDesc: "Rider",
          strDsName: "ROLE_RIDER",
        },
      ],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      TypeOptions: [
        {
          intDsId: 1,
          strDsDesc: "คลังสินค้า",
        },
        {
          intDsId: 2,
          strDsDesc: "Warehouse",
        },
      ],
      ori_country: [],
      CountryOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_province: [],
      provinceOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_district: [],
      districtOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_subdistrict: [],
      subdistrictOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_postcode: [],
      postcodeOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      pageLength: 3,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          key: "action",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อผู้ติดต่อ",
          key: "strContactName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อเล่น",
          key: "strNickName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เบอร์โทร",
          key: "strTelNo",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "อีเมลล์",
          key: "strEmail",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "หน่วยงาน",
          key: "strDepartment",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ตำแหน่ง",
          key: "strPosition",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      searchTerm: "",
      searchOwner: "",
      listData: {
        intUserId: -1,
        intCustomerId: -1,
        strCustomerName: "",
        intTypeId: 2,
        strType: "",
        strTaxId: "",
        error1: "",
        error2: "",
        select_flag: true,
        strName: "",
        strFirstName: "",
        strSurName: "",
        strEmail: "",
        strTelNo: "",
        intDeptId: "",
        intRole: "",
        strRole: "",
      },
      listDetails: [],
    };
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    stateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailPattern.test(this.listData.strEmail);
      return this.isEmailValid;
    },
    stateTelNo() {
      const telPattern = /^[\d\s\-()]+$/;
      this.isTelNoValid = telPattern.test(this.listData.strTelNo);
      return this.isTelNoValid;
    },
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailPattern.test(this.listData.strEmail);

      if (this.listData.strEmail == "" || !this.isEmailValid) {
        return "Enter Email Format.";
      }
      return "Please enter something.";
    },
    validateTelNo() {
      // Example pattern: allows digits, spaces, hyphens, and parentheses
      const telPattern = /^[\d\s\-()]+$/;
      this.isTelNoValid = telPattern.test(this.listData.strTelNo);

      if (this.listData.strTelNo == "" || !this.isTelNoValid) {
        return "Enter TelNo.";
      }
      return "Please enter something.";
    },
  },
  mounted() {
    let Id = localStorage.getItem("user-id");
    let lang = localStorage.getItem("language");

    //serviceOptions
    Service.getAllDropdownForCustomerForm({})
      .then((response) => {
        console.log(response.data);
        let etcobj = {
          intDsId: 9999,
          strDsName: "ETC",
          strDsDesc: "ETC",
          intRefId: -1,
          strRefDesc: "ETC",
        };

        //  ori_province provinceOptions ori_district districtOptions
        //  ori_subdistrict subdistrictOptions  ori_postcode postcodeOptions
        this.ori_province = [];
        response.data.lstProvince.forEach((e) => {
          this.ori_province.push(e);
        });
        let newlist15 = [];
        this.provinceOptions = [];
        newlist15 = this.ori_province.filter((a) => a.strLanguage == lang);
        newlist15.forEach((f) => {
          this.provinceOptions.push(f);
        });

        this.ori_district = [];
        response.data.lstDistrict.forEach((e) => {
          this.ori_district.push(e);
        });
        let newlist16 = [];
        this.districtOptions = [];
        newlist16 = this.ori_district.filter((a) => a.strLanguage == lang);
        newlist16.forEach((f) => {
          this.districtOptions.push(f);
        });
        this.districtOptions.push(etcobj);

        this.ori_subdistrict = [];
        response.data.lstSubDistrict.forEach((e) => {
          this.ori_subdistrict.push(e);
        });
        let newlist17 = [];
        this.subdistrictOptions = [];
        newlist17 = this.ori_subdistrict.filter((a) => a.strLanguage == lang);
        newlist17.forEach((f) => {
          this.subdistrictOptions.push(f);
        });
        this.subdistrictOptions.push(etcobj);

        this.ori_postcode = [];
        response.data.lstPostcode.forEach((e) => {
          this.ori_postcode.push(e);
        });
        let newlist18 = [];
        this.postcodeOptions = [];
        newlist18 = this.ori_postcode;
        newlist18.forEach((f) => {
          this.postcodeOptions.push(f);
        });
        this.postcodeOptions.push(etcobj);

        this.departmentOption = [];
        response.data.lstDepartment.forEach((g) => {
          this.departmentOption.push(g);
        });

        this.busy = false;
        this.isLoading = false;
      })
      .catch((error) => {
        this.busy = false;
        this.isLoading = false;
      });

    if (Id == -1) {
      var new_date = moment().add(1, "days");
      new_date = new_date.format("DD/MM/YYYY");

      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "สร้างเอกสาร",
            icon: "PlusIcon",
            variant: "success",
            text: "สร้างเอกสารใหม่",
          },
        },
        {
          position: "top-center",
        }
      );
    } else {
      UserService.getFormUser({ intUserId: Id })
        .then((response) => {
          this.listData = {
            intUserId: -1,
            intCustomerId: -1,
            strCustomerName: "",
            intTypeId: 2,
            strType: "",
            strTaxId: "",
            error1: "",
            error2: "",
            select_flag: false,
            strName: "",
            strFirstName: "",
            strSurName: "",
            strEmail: "",
            strTelNo: "",
            intDeptId: "",
            intRole: "",
            strRole: "",
          };

          let data = response.data.headerGrid;
          this.listData.intUserId = data.id;
          this.listData.strName = data.username;
          this.listData.strFirstName = data.firstname;
          this.listData.strSurName = data.surname;
          this.listData.strEmail = data.email;
          this.listData.strTelNo = data.telno;
          this.listData.strOldPassword = data.password;
          this.listData.intDeptId = data.intdeptid;
          this.listData.strRole = data.role;

          this.isEdit = true;
          this.showName = " (" + this.listData.strName + ") ";
          this.showStatus = this.listData.strStatus;
          this.showBy = this.listData.strCreatedBy;

          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "แก้ไข User",
                icon: "EditIcon",
                variant: "warning",
                text: "แก้ไข User : " + this.listData.strName,
              },
            },
            {
              position: "top-center",
            }
          );
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    }
  },
  methods: {
    showMessage() {
      this.enterPressed = true;
      setTimeout(() => {
        this.enterPressed = false;
      }, 3000);
    },
    showMessage2() {
      this.enterPressed2 = true;
      setTimeout(() => {
        this.enterPressed2 = false;
      }, 3000);
    },
    async checkAndCompressListService(mode, input) {
      if (mode == "Cust") {
        if (this.listData.strFile != null) {
          this.listData.strFile.forEach((file, fileindex) => {
            if (file.size > 1048576 && file.type.startsWith("image/")) {
              let filename = file.name;
              let title =
                "The file " +
                filename +
                " is larger than 1 MB. Do you want to compress it?";
              this.$bvModal
                .msgBoxConfirm(title, {
                  title: "Compress Image?",
                  size: "m",
                  modalClass: "modal-success",
                  okVariant: "success",
                  okTitle: "Compress",
                  cancelTitle: "Cancel",
                  cancelVariant: "outline-warning",
                  hideHeaderClose: false,
                  //centered: true,
                })
                .then((value) => {
                  if (value) {
                    this.compressImage(mode, 1, index, fileindex);
                  } else {
                    this.listData.strFile = null;
                  }
                });
            }
          });
        }
      }
      if (mode == "Addr") {
        this.listAddr.forEach((file, fileindex) => {
          if (file.strFile != null) {
            if (file.size > 1048576 && file.type.startsWith("image/")) {
              let filename = file.name;
              let title =
                "The file " +
                filename +
                " is larger than 1 MB. Do you want to compress it?";
              this.$bvModal
                .msgBoxConfirm(title, {
                  title: "Compress Image?",
                  size: "m",
                  modalClass: "modal-success",
                  okVariant: "success",
                  okTitle: "Compress",
                  cancelTitle: "Cancel",
                  cancelVariant: "outline-warning",
                  hideHeaderClose: false,
                  //centered: true,
                })
                .then((value) => {
                  if (value) {
                    this.compressImage(mode, 1, index, fileindex);
                  } else {
                    file.strFile = null;
                  }
                });
            }
          }
        });
      }
    },
    tbuildFile(blob, name) {
      return new File([blob], name);
    },
    ttoBlob(imgUrl) {
      let blob = base64toblob(imgUrl.split(",")[1], "image/jpeg");
      let url = window.URL.createObjectURL(blob);
      return url;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to an ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var _ia = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
      }
      var dataView = new DataView(arrayBuffer);
      var blob = new Blob([dataView], { type: mimeString });
      return blob;
    },
    compressImage(mode, input, index, fileindex) {
      let file;
      if (mode == "Cust") {
        file = this.listData.strFile[fileindex];
      }
      if (mode == "Addr") {
        file = this.listAddr[index].strFile[fileindex];
      }

      let imageData = null;
      let context = null;
      let maxWidth = 2400;
      let maxHeigt = 2400;
      let width = maxWidth;
      let height = maxHeigt;
      let vm = this;

      let reader = new FileReader();
      let name = file.name;

      let img = new Image();
      var canvas = document.createElement("canvas");
      reader.onload = function (e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = function () {
        // Draw
        context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);

        if (img.width > maxWidth || img.height > maxHeigt) {
          width = maxWidth;
          height = maxHeigt;

          if (img.width > maxWidth) {
            width = maxWidth;
            var ration = maxWidth / img.width;
            height = Math.round(img.height * ration);
          }

          if (img.height > maxHeigt) {
            height = maxHeigt;
            var ration = maxHeigt / img.height;
            width = Math.round(img.width * ration);
          }
        } else {
          width = img.width;
          height = img.height;
        }
        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);

        var objToPass = {};

        // Quality Of Image
        let quality = 100 / 100;
        imageData = canvas.toDataURL("image/jpeg", quality);
        imageData.replace("data:image/jpeg;base64,", "");
        let tblobToFile = vm.ttoBlob(imageData);
        let blobToFile = vm.dataURItoBlob(imageData);

        //console.log("imageData", imageData);
        //console.log(tblobToFile);
        //console.log(blobToFile);

        for (let qty = 100; blobToFile.size > 1048576 && qty > 0; ) {
          qty = qty - 10;
          quality = qty / 100;
          imageData = canvas.toDataURL("image/jpeg", quality);
          imageData.replace("data:image/jpeg;base64,", "");
          tblobToFile = vm.ttoBlob(imageData);
          blobToFile = vm.dataURItoBlob(imageData);
        }

        /* objToPass = {
          canvas: canvas,
          name: name,
          size: blobToFile.size,
          readsize: blobToFile.size / 1000,
          type: "image/jpeg",
          compressed: {
            blob: tblobToFile,
            base64: imageData,
            name: name,
            size: blobToFile.size,
            file: vm.tbuildFile(imageData, name),
          },
        }; */

        if (mode == "Cust") {
          vm.listData.strFile[fileindex] = vm.tbuildFile(imageData, name);
        }
        if (mode == "Addr") {
          vm.listAddr[index].strFile[fileindex] = vm.tbuildFile(
            imageData,
            name
          );
        }
      };
    },
    onChangeVal(inputid, mode) {
      if (inputid != "" && inputid != null) {
        if (mode == "type") {
          let currType = this.TypeOptions.find((t) => t.intDsId === inputid);
          this.listData.strType = currType.strDsDesc;
        }
        if (mode == "mainInd") {
          let currMain = this.MainOptions.find((t) => t.intDsId === inputid);
          this.listData.strIndusMainDesc = currMain.strDsDesc;
        }
        if (mode == "subInd") {
          let currSub = this.MainOptions.find((t) => t.intDsId === inputid);
          this.listData.strIndusSubDesc = currSub.strDsDesc;
        }
        if (mode == "source") {
          let currss = this.TestOptions.find((t) => t.intDsId === inputid);
          this.listData.strSource = currss.strDsDesc;
        }
        if (mode == "leadstage") {
          let currlead = this.leadstage.find((t) => t.intDsId === inputid);
          this.listData.strLead = currlead.strDsDesc;
        }
      }
    },
    onChangeAddr(index, inputid, mode) {
      if (inputid != "" && inputid != null) {
        if (mode == "country") {
          let currcountry = this.CountryOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strCountry = currcountry.strDsDesc;
        }
        if (mode == "province") {
          let currprovince = this.provinceOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strProvince = currprovince.strDsDesc;
          this.listAddr[index].intDistrictId = "";
          this.listAddr[index].strDistrict = "";
          this.listAddr[index].intSubDistrictId = "";
          this.listAddr[index].strSubDistrict = "";
          this.listAddr[index].intPostcodeId = "";
          this.listAddr[index].strPostcode = "";
        }
        if (mode == "district") {
          let currdistrict = this.districtOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strDistrict = currdistrict.strDsDesc;
          this.listAddr[index].intSubDistrictId = "";
          this.listAddr[index].strSubDistrict = "";
          this.listAddr[index].intPostcodeId = "";
          this.listAddr[index].strPostcode = "";
        }
        if (mode == "subdistrict") {
          let currsubdistrict = this.subdistrictOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strSubDistrict = currsubdistrict.strDsDesc;
        }
        if (mode == "postcode") {
          let currpostcode = this.postcodeOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strPostcode = currpostcode.strDsDesc;
        }
      }
    },
    onSubmit(inputstatus) {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";

      this.$refs.headerForm.validate().then((success) => {
        if (success) {
          this.listData.error1 = "";
          this.listData.error2 = "";

          if (
            this.listData.strInputPassword != this.listData.strConfirmPassword
          ) {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "รหัสผ่านไม่ตรงกัน!";
              errorsmsg = errorsmsg + "รหัสผ่านไม่ตรงกัน";
            } else {
              this.listData.error2 = "Password confirmation does not match.!";
              errorsmsg = errorsmsg + " Password confirmation does not match.";
            }
          }

          if (this.listData.strEmail == "" || !this.isEmailValid) {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "อีเมลล์ ไม่ถูกต้อง!";
              errorsmsg = errorsmsg + "อีเมลล์ ไม่ถูกต้อง";
            } else {
              this.listData.error2 = "Email is incorrect.";
              errorsmsg = errorsmsg + " Email is incorrect.";
            }
          }

          if (this.listData.strTelNo == "" || !this.isTelNoValid) {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "เบอร์โทรศัพท์ ไม่ถูกต้อง!";
              errorsmsg = errorsmsg + "เบอร์โทรศัพท์ ไม่ถูกต้อง";
            } else {
              this.listData.error2 = "TelNo is incorrect.";
              errorsmsg = errorsmsg + " TelNo is incorrect.";
            }
          }

          if (this.listData.strRole == "") {
            ifcomp = false;
            if (lang == "th_TH") {
              this.listData.error2 = "Role ไม่ถูกต้อง!";
              errorsmsg = errorsmsg + "Role ไม่ถูกต้อง";
            } else {
              this.listData.error2 = "Role is incorrect.";
              errorsmsg = errorsmsg + " Role is incorrect.";
            }
          }

          if (!ifcomp) {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "WARNING!!",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                  text: "" + errorsmsg,
                },
              },
              {
                position: "top-center",
                timeout: 10000,
              }
            );
            return;
          }
          //ifcomp
          if (ifcomp) {
            this.busy = false;
            this.processing = false;
            //this.busy = true;
            this.strInputStatus = inputstatus;
            this.strStatusShow = "Confirm " + inputstatus;
            let b1 = inputstatus;
            let b2 = "Cancel";

            if (lang == "th_TH") {
              b1 = "ยืนยัน";
              b2 = "ยกเลิก";
              if (inputstatus == "Submit") {
                this.strStatusShow = "ยืนยันการบันทึกข้อมูล";
              } else {
                this.strStatusShow = "ยืนยันการบันทึกร่าง";
              }
            }

            this.$bvModal
              .msgBoxConfirm(this.strStatusShow, {
                title: this.strStatusShow,
                size: "sm",
                modalClass: "modal-success",
                okVariant: "success",
                okTitle: b1,
                cancelTitle: b2,
                cancelVariant: "outline-warning",
                hideHeaderClose: false,
                //centered: true,
              })
              .then((value) => {
                if (value) {
                  this.onSave();
                }
              });
          }
        } else {
          let message = "";

          let titlemsg = "Please Fill in below details ";
          let alertmsg = "Please Select ";
          if (lang == "th_TH") {
            alertmsg = "กรุณาเลือก";
            titlemsg = "กรอกข้อมูลให้ครบถ้วน ";
          }
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: titlemsg,
                icon: "AlertCircleIcon",
                variant: "danger",
                text: alertmsg + message,
              },
            },
            {
              position: "top-center",
              timeout: 10000,
            }
          );
        }
      });
    },
    onSave() {
      let inputstatus = this.strInputStatus;
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      this.isSaving = true;
      // var dataSave = {
      //   headerGrid: this.listData,
      //   intUserId: this.listData.intUserId,
      //   status: this.strInputStatus,
      // };

      let currdept = this.departmentOption.find(
        (c) => c.intDeptId === this.listData.intDeptId
      );
      if (currdept) {
        this.listData.strDeptName = currdept.strDeptName;
      }

      var dataSave = {
        intUserId: this.listData.intUserId,
        strTypeUser: this.listData.strTypeUser,
        strUserName: this.listData.strName,
        strName: this.listData.strName,
        strFirstName: this.listData.strFirstName,
        strSurName: this.listData.strSurName,
        strTelNo: this.listData.strTelNo,
        strEmail: this.listData.strEmail,
        intDeptId: this.listData.intDeptId,
        strDeptName: this.listData.strDeptName,
        strPassword: this.listData.strInputPassword,
        strConfirmPass: this.listData.strConfirmPassword,
        strChangePass: this.listData.strChangePass,
        strRole: this.listData.strRole,
        strPassFlag: this.listData.select_flag,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      formData.append("strJson", JSON.stringify(dataSave));

      UserService.saveUser2(formData)
        .then((response) => {
          if (response.data.status == "500") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            this.$router.replace({ name: "user-search" }).then(() => {
              let compmsg = "Save Completed";
              if (lang == "th_TH") {
                compmsg = "บันทึกสำเร็จ";
              }
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: compmsg,
                    icon: "CheckIcon",
                    variant: "success",
                    text: response.data.message,
                  },
                },
                {
                  position: "top-center",
                }
              );
            });
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onBack() {
      this.$router.push({ name: "user-search" });
    },
    onchangeStringtoDouble(input) {
      let value;
      if (typeof input === "string") {
        value = Number.parseFloat(input.replaceAll(",", ""));
      } else if (typeof input === "string" && (input == "" || input == null)) {
        value = 0;
      } else {
        value = input;
      }
      return value;
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
